import { Typography, TypographyProps } from '@mui/material';
import { FC } from 'react';

interface TextWithLineBreaksProps extends TypographyProps {
  children: string;
}

const TextWithLineBreaks: FC<TextWithLineBreaksProps> = ({ children, ...props }) => {
  const normalized = children?.replace(/\\n/g, '\n');

  return (
    <Typography sx={{ whiteSpace: 'pre-wrap' }} {...props}>
      {normalized}
    </Typography>
  );
};

export default TextWithLineBreaks;
